"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnswered = exports.withOtherText = exports.EMPTY_DRAFT = void 0;
exports.pickOption = pickOption;
exports.toggleOther = toggleOther;
exports.answersFrom = answersFrom;
exports.nextUnanswered = nextUnanswered;
exports.EMPTY_DRAFT = { selected: [], other: '', otherOn: false };
/** A choice on a single-select replaces the last one, Other included; on a multi-select it toggles. */
function pickOption(question, draft, label) {
    if (!question.multiSelect)
        return { ...draft, selected: [label], otherOn: false };
    const selected = draft.selected.includes(label)
        ? draft.selected.filter((picked) => picked !== label)
        : [...draft.selected, label];
    return { ...draft, selected };
}
/** Other on a single-select is chosen instead of an option; on a multi-select it toggles. */
function toggleOther(question, draft) {
    if (!question.multiSelect)
        return { ...draft, selected: [], otherOn: true };
    return { ...draft, otherOn: !draft.otherOn };
}
const withOtherText = (draft, other) => ({
    ...draft,
    other,
});
exports.withOtherText = withOtherText;
const typed = (draft) => {
    const other = draft.other.trim();
    return draft.otherOn && other ? other : undefined;
};
const isAnswered = (draft) => Boolean(draft && (draft.selected.length > 0 || typed(draft)));
exports.isAnswered = isAnswered;
function answersFrom(questions, drafts) {
    return {
        answers: questions.map((question, i) => {
            const draft = drafts[i] ?? exports.EMPTY_DRAFT;
            const other = typed(draft);
            return {
                question: question.question,
                selected: [...draft.selected],
                ...(other ? { other } : {}),
            };
        }),
    };
}
/** The next question still waiting, looking after `from` first and then wrapping round. */
function nextUnanswered(questions, drafts, from) {
    for (let step = 1; step <= questions.length; step++) {
        const at = (from + step) % questions.length;
        if (!(0, exports.isAnswered)(drafts[at]))
            return at;
    }
    return undefined;
}
